import { instance as axios, setJwtToken } from "../../config/axiosInstance";

// ---------------------fatch-meetups-listing--------------------------
export const getMeetupsListApi = async (data) => {
  const endPoint =
    `/community/meetup_list` +
    "?" +
    new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};
// ---------------------change-status-meetups--------------------------
export const changeMeetupsStatusApi = async (data) => {
  return await axios.post(`/community/meetup_status`, data, setJwtToken());
};
export const hideMeetupApi = async (id) => {
  return await axios.get(`/community/meetup_hide/${id}`, setJwtToken());
};
// --------------------meetups-details---------------------------
export const meetupsDetailsApi = async (id) => {
  return await axios.get(`/community/meetup_detail/${id}`, setJwtToken());
};
// -------------------intetested-member-details---------------------------
export const getInterestedMemberListApi = async (data) => {
  const endPoint =
    `/community/interested_list` +
    `?` +
    new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};
// -------------------delete-meetups---------------------------
export const deleteMeetupsApi = async (id) => {
  return await axios.delete(`/community/meetup_delete/${id}`, setJwtToken());
};
